import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AppProviders } from './providers/AppProviders'
import { BrowserRouter } from 'react-router-dom'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProviders>
  </React.StrictMode>
)
